module.exports = __webpack_public_path__ + "img/michael-relth-untitled.80af2ee.jpg";